export default "__VITE_ASSET__CvVIqLJo__"